import { smallestBBox, getPolygonArea } from "@project-rouge/rg-three";
import { SplitDirection } from "./index185.js";
function isValidSubdivision({
  polygon,
  splitOption,
  minWidth,
  maxLength,
  minArea,
  rng,
  count,
  maxCount,
  splitLikelihood = 0.5
}) {
  const bBox = smallestBBox(polygon);
  const currentArea = getPolygonArea(polygon);
  const minFactor = splitOption.minFactor;
  const maxEdgeLength = bBox.maxSides[0].length;
  const minEdgeLength = bBox.minSides[0].length;
  const isCountExceeded = count + 1 > maxCount;
  if (isCountExceeded)
    return false;
  const isMinWidthViolated = checkMinWidth({ splitOption, maxEdgeLength, minEdgeLength, minFactor, minWidth });
  if (isMinWidthViolated)
    return false;
  const isTooLong = maxEdgeLength > maxLength;
  if (isTooLong && splitOption.direction === SplitDirection.transverse) {
    return true;
  }
  if (isTooLong && splitOption.direction === SplitDirection.longitudinal) {
    return false;
  }
  const isAreaTooSmall = currentArea * minFactor < minArea;
  if (isAreaTooSmall)
    return false;
  if (rng) {
    return rng() < splitLikelihood;
  } else {
    return true;
  }
}
function checkMinWidth({ splitOption, maxEdgeLength, minEdgeLength, minFactor, minWidth }) {
  let isMinWidthViolated = false;
  if (splitOption.direction === SplitDirection.transverse) {
    isMinWidthViolated = maxEdgeLength * minFactor < minWidth;
  } else {
    isMinWidthViolated = minEdgeLength * minFactor < minWidth;
  }
  return isMinWidthViolated;
}
export {
  isValidSubdivision
};
//# sourceMappingURL=index231.js.map
